function sortRequests(collection) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  // Stop the recursion if we don't have anything that needs bubbling
  if (collection.length === 0) {
    return collection;
  }

  var afters = collection.map(function (_ref) {
    var after = _ref.after;
    return after;
  }).filter(function (after) {
    return !!after;
  });
  var firsts = collection.filter(function (_ref2) {
    var adId = _ref2.adId;
    return afters.indexOf(adId) !== -1;
  });
  var lasts = collection.filter(function (item) {
    return firsts.indexOf(item) === -1;
  });
  var sortedFirsts = firsts;
  /*
    Checking lasts length prevents circular deps. Eg:
    [
      { adId: 'foo', after: 'abc' },
      { adId: 'abc', after: 'foo' },
    ]
     Will result in a `firsts` that looks like:
    [
      { adId: 'foo', after: 'abc' },
      { adId: 'abc', after: 'foo' },
    ]
     And a `lasts` that looks like:
    [ ]
  */

  if (lasts.length !== 0) {
    // Recurse
    sortedFirsts = sortRequests(firsts, count + 1);
  }

  return sortedFirsts.concat(lasts);
}

export default sortRequests;